import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 111px;
  max-width: 819px;

`;

export const LoaderWrapper = styled.span`
  right: 0;
  z-index: 10;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`
